import { Route } from '@angular/router';
import { AuthCacheService, AuthenticatedGuardCanActivateChild, AuthPagesHelpersService } from '@pinnakl/auth/providers';
import { DEDICATED_INVESTOR_PORTAL_ROUTES } from '@pinnakl/dedicated-investor-portal/shell';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    providers: [AuthPagesHelpersService, AuthCacheService],
    loadChildren: () => import('@pinnakl/auth/shell').then(m => m.AUTH_ROUTES),
  },
  {
    path: '',
    canActivateChild: [AuthenticatedGuardCanActivateChild],
    children: DEDICATED_INVESTOR_PORTAL_ROUTES,
  },
  {
    path: 'access-denied',
    loadComponent: () => import('@pinnakl/shared/pages').then(m => m.AccessDeniedComponent),
  },
];
